import * as React from "react";
import { useApiService } from "../hooks";
import { WorkbookApi } from "../api";
import { useApiEffect } from "nsitools-react";

export interface IWorkbookTypeIconProps {
  workbookTypeId: number;
}

export const WorkbookTypeIcon: React.FunctionComponent<IWorkbookTypeIconProps> = ({ workbookTypeId }) => {
  const api = useApiService(WorkbookApi);

  const [data] = useApiEffect(async () => api.getWorkbookIconInformation(workbookTypeId));

  return (
    data &&
    (data.hasPedigree ? (
      <i className="fas fa-circle" style={{ color: data.color }} />
    ) : (
      <i className="fas fa-times-circle" style={{ color: data.color }} />
    ))
  );
};
